(function () {
  var SCENARIOS = [
    {
      query: 'Where can I clean a suede jacket near me?',
      checks: [
        ['Customer location', 'SE1, London'],
        ['Garment type', 'Suede jacket'],
        ['Specialism', 'Leather & suede'],
        ['Availability', 'Collects Tue'],
        ['Approved status', 'Verified']
      ],
      partner: {
        initials: 'HC',
        name: 'Harrow & Clay',
        area: 'Bermondsey',
        distance: '1.2 miles away',
        rating: '4.9',
        tags: ['Leather & suede', 'Colour restoration', 'Collection & delivery']
      }
    },
    {
      query: 'Who can safely clean my wedding dress?',
      checks: [
        ['Customer location', 'Didsbury'],
        ['Garment type', 'Bridal gown'],
        ['Specialism', 'Bridalwear'],
        ['Availability', '8-day care'],
        ['Approved status', 'Verified']
      ],
      partner: {
        initials: 'LM',
        name: 'Lockwood & Moss',
        area: 'Didsbury',
        distance: '2.4 miles away',
        rating: '5.0',
        tags: ['Bridalwear', 'Hand finishing', 'Boxed preservation']
      }
    },
    {
      query: 'I need a trusted luxury dry cleaner.',
      checks: [
        ['Customer location', 'Clifton'],
        ['Garment type', 'Cashmere coat'],
        ['Specialism', 'Luxury garments'],
        ['Availability', 'Same week'],
        ['Approved status', 'Verified']
      ],
      partner: {
        initials: 'AV',
        name: 'Ashgrove Couture Care',
        area: 'Clifton',
        distance: '0.8 miles away',
        rating: '4.9',
        tags: ['Luxury garments', 'Garment Passport', 'Hand finishing']
      }
    },
    {
      query: 'Where should I take this damaged designer coat?',
      checks: [
        ['Customer location', 'Leith'],
        ['Garment type', 'Wool overcoat'],
        ['Specialism', 'Repair & restoration'],
        ['Availability', 'Assess in 48h'],
        ['Approved status', 'Verified']
      ],
      partner: {
        initials: 'TR',
        name: 'Thistle Row Garment Care',
        area: 'Leith',
        distance: '1.6 miles away',
        rating: '4.8',
        tags: ['Repair & restoration', 'Reweaving', 'Condition reporting']
      }
    }
  ];

  function init(root) {
    if (!root || root.dataset.sdApprovedReady === '1') return;
    root.dataset.sdApprovedReady = '1';

    var typedEl = root.querySelector('[data-sd-approved-typed]');
    var progressEl = root.querySelector('[data-sd-approved-progress]');
    var checksEl = root.querySelector('[data-sd-approved-checks]');
    var searchingEl = root.querySelector('[data-sd-approved-searching]');
    var matchedEl = root.querySelector('[data-sd-approved-matched]');
    var initialsEl = root.querySelector('[data-sd-approved-initials]');
    var nameEl = root.querySelector('[data-sd-approved-name]');
    var metaEl = root.querySelector('[data-sd-approved-meta]');
    var tagsEl = root.querySelector('[data-sd-approved-tags]');
    var ratingEl = root.querySelector('[data-sd-approved-rating]');

    var state = {
      scenario: 0,
      phase: 0,
      chars: 0,
      checkStep: 0,
      sub: 0,
      hold: 0
    };

    function renderChecks() {
      var sc = SCENARIOS[state.scenario];
      var html = '';
      for (var i = 0; i < sc.checks.length; i++) {
        var on = state.phase >= 1 && i < state.checkStep;
        var active = state.phase === 1 && i === state.checkStep;
        var label = sc.checks[i][0];
        var value = on ? sc.checks[i][1] : active ? 'matching…' : '';
        var mark = on ? '✓' : '';
        html +=
          '<div class="sd-approved-hero__check' +
          (on ? ' is-on' : '') +
          '">' +
          '<span class="sd-approved-hero__check-dot" aria-hidden="true">' +
          mark +
          '</span>' +
          '<span class="sd-approved-hero__check-label">' +
          label +
          '</span>' +
          '<span class="sd-approved-hero__check-value">' +
          value +
          '</span>' +
          '</div>';
      }
      checksEl.innerHTML = html;
    }

    function renderPartner() {
      var partner = SCENARIOS[state.scenario].partner;
      initialsEl.textContent = partner.initials;
      nameEl.textContent = partner.name;
      metaEl.textContent = partner.area + ' · ' + partner.distance;
      ratingEl.textContent = partner.rating;
      tagsEl.innerHTML = partner.tags
        .map(function (t) {
          return '<span class="sd-approved-hero__tag">' + t + '</span>';
        })
        .join('');
    }

    function progressWidth() {
      var sc = SCENARIOS[state.scenario];
      var pct;
      if (state.phase === 0) {
        pct = (state.chars / sc.query.length) * 0.4;
      } else if (state.phase === 1) {
        pct = 0.4 + (state.checkStep / sc.checks.length) * 0.6;
      } else {
        pct = 1;
      }
      return Math.round(pct * 100) + '%';
    }

    function render() {
      var sc = SCENARIOS[state.scenario];
      var done = state.phase === 2;
      typedEl.textContent = sc.query.slice(0, state.chars);
      progressEl.style.width = progressWidth();
      renderChecks();
      searchingEl.hidden = done;
      matchedEl.hidden = !done;
      if (done) renderPartner();
    }

    function advance() {
      var sc = SCENARIOS[state.scenario];
      if (state.phase === 0) {
        if (state.chars < sc.query.length) {
          state.chars += 1;
          render();
          return;
        }
        state.phase = 1;
        state.hold = 0;
        render();
        return;
      }
      if (state.phase === 1) {
        if (state.checkStep < sc.checks.length) {
          if (state.sub < 3) {
            state.sub += 1;
            render();
            return;
          }
          state.checkStep += 1;
          state.sub = 0;
          render();
          return;
        }
        state.phase = 2;
        state.hold = 0;
        render();
        return;
      }
      state.hold += 1;
      if (state.hold < 42) return;
      state.scenario = (state.scenario + 1) % SCENARIOS.length;
      state.phase = 0;
      state.chars = 0;
      state.checkStep = 0;
      state.sub = 0;
      state.hold = 0;
      render();
    }

    render();
    var tick = setInterval(advance, 90);

    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) {
          clearInterval(tick);
          tick = null;
        } else if (!tick) {
          tick = setInterval(advance, 90);
        }
      },
      false
    );
  }

  function boot() {
    document.querySelectorAll('[data-sd-approved-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-sd-approved-hero]');
    if (root) {
      root.dataset.sdApprovedReady = '';
      init(root);
    }
  });
})();
